"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MobiledocTypes = require("./types/Mobiledoc");
exports.MobiledocTypes = MobiledocTypes;
var SectionRenderer_1 = require("./SectionRenderer");
var upgradeMobiledoc_1 = require("./upgradeMobiledoc");
exports.upgradeMobiledoc = upgradeMobiledoc_1.default;
var getMarkupComponentDefault_1 = require("./getMarkupComponentDefault");
exports.getMarkupComponentDefault = getMarkupComponentDefault_1.default;
var utils_1 = require("./utils");
exports.SUPPORTED_MOBILEDOC_VERSION = '0.3.1';
exports.canParse = utils_1.semverMatchesMinor(exports.SUPPORTED_MOBILEDOC_VERSION);
exports.default = (function (_a) {
    var _b = _a.createElement, createElement = _b === void 0 ? function () {
        return utils_1.throwError("You must pass a `createElement` (`(type, properties, children) => Node`) function to `MobiledocVdomRenderer` in order to render output.");
    } : _b, _c = _a.getCardComponent, getCardComponent = _c === void 0 ? function (type) {
        return utils_1.throwError("You must pass a `getCardComponent` (`type => Component`) function to `MobiledocVdomRenderer` in order to render cards (i.e. `'" + type + "'`).");
    } : _c, _d = _a.getAtomComponent, getAtomComponent = _d === void 0 ? function (type) {
        return utils_1.throwError("You must pass a `getAtomComponent` (`type => Component`) function to `MobiledocVdomRenderer` in order to render atoms (i.e. `'" + type + "'`).");
    } : _d, _e = _a.getMarkupComponent, getMarkupComponent = _e === void 0 ? getMarkupComponentDefault_1.default : _e;
    return function (mobiledoc) {
        return exports.canParse(mobiledoc.version)
            ? mobiledoc.sections.map(SectionRenderer_1.default({
                createElement: createElement,
                getCardComponent: getCardComponent,
                getAtomComponent: getAtomComponent,
                getMarkupComponent: getMarkupComponent
            })({
                markups: mobiledoc.markups,
                cards: mobiledoc.cards,
                atoms: mobiledoc.atoms
            }))
            : utils_1.throwError("Unable to parse the passed Mobiledoc version `'" + mobiledoc.version + "'`.");
    };
});
